export const MARKING_SERVICE_ID = 38;
export const OFFER_RATE_WITH_MARKING = 1.03;
export const MARKING_RATE = 0.03;
